import React from 'react';
import { Box, Skeleton, styled } from '@mui/material';

const LoadingContainer = styled(Box)(({ theme }) => ({
    display: 'grid',
    width: '100%',
    gap: '10px',
    gridTemplateColumns: 'repeat(2, 1fr)',
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
    },
}));

export const ProductPageLoadingLayout = () => {
    return (
        <LoadingContainer>
            <Box>
                <Skeleton
                    variant="rectangular"
                    sx={{ width: '100%' }}
                    height={200}
                />
            </Box>
            <Box>
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            </Box>
        </LoadingContainer>
    );
};
